import { TableCell, Text } from "@amzn/meridian";
import { TableCellProps } from "@amzn/meridian/table/table-cell";
import { TextProps } from "@amzn/meridian/text/text";

interface TableCellRendererProps extends TableCellProps {
  data: string | number | boolean | Date;
  textColor?: TextProps["color"];
}
const TableCellRenderer = ({
  data,
  textColor = "primary",
  ...rest
}: TableCellRendererProps) => {
  const getCellData = () => {
    if (typeof data === "string") {
      return data.trim();
    } else if (typeof data === "number") {
      return data.toString();
    } else if (typeof data === "boolean") {
      return data ? "Yes" : "No";
    } else if (data instanceof Date) {
      return data.toLocaleString();
    }
  };

  return (
    <TableCell {...rest}>
      <Text color={textColor}>{getCellData()}</Text>
    </TableCell>
  );
};

export default TableCellRenderer;
